import { useCallback } from "react";
import { useMasterDataDistributionCenters } from "@src/presentation/providers/MasterDataDistributionCentersDataProvider";
import { invalidateMasterDataListCacheScopes } from "@src/presentation/providers/masterData/masterDataListCache";
import { MasterDataDistributionCenterAddEditForm } from "../utils/MasterDataDistributionCenterAddEditForm";
import { MasterDataDistributionCentersTable } from "../utils/MasterDataDistributionCentersTable";
import { MasterDataWritableListLayout } from "../utils/MasterDataWritableListLayout";
import { formatMasterDataRecordCount } from "../utils/useMasterDataAddEditModal";
import { useMasterDataDistributionCenterForm } from "../utils/useMasterDataDistributionCenterForm";

export const MasterDataDistributionCentersPage = () => {
  const {
    distributionCenters,
    loading,
    search,
    setSearch,
    total,
    setPage,
    refetch,
  } = useMasterDataDistributionCenters();

  const handleSaved = useCallback(() => {
    invalidateMasterDataListCacheScopes(["purchasers", "purchaser-dc-modal"]);
    setPage(1);
    refetch();
  }, [refetch, setPage]);

  const {
    form,
    formMode,
    isSaving,
    isFormSubmittable,
    setIsFormSubmittable,
    initialValues,
    purchaserOptions,
    purchasersLoading,
    isPurchaserLocked,
    lockedPurchaserName,
    openCreate,
    openEdit,
    closeForm,
    handleSubmit,
  } = useMasterDataDistributionCenterForm({
    onSaved: handleSaved,
  });

  return (
    <MasterDataWritableListLayout
      title="Purchaser Distribution Centers"
      subtitle={formatMasterDataRecordCount(loading, total)}
      searchPlaceholder="Search purchaser distribution centers"
      search={search}
      setSearch={setSearch}
      searchSection="distribution-centers"
      addButtonLabel="Add DC"
      onAdd={openCreate}
      loading={loading && formMode == null}
    >
      {formMode != null ? (
        <MasterDataDistributionCenterAddEditForm
          form={form}
          mode={formMode}
          initialValues={initialValues}
          isPurchaserLocked={isPurchaserLocked}
          lockedPurchaserName={lockedPurchaserName}
          purchaserOptions={purchaserOptions}
          purchasersLoading={purchasersLoading}
          isSaving={isSaving}
          isFormSubmittable={isFormSubmittable}
          onSubmit={handleSubmit}
          onCancel={() => closeForm()}
          onFormValidityChange={setIsFormSubmittable}
        />
      ) : null}
      <MasterDataDistributionCentersTable
        distributionCenters={distributionCenters}
        search={search}
        setSearch={setSearch}
        setPage={setPage}
        onEdit={openEdit}
      />
    </MasterDataWritableListLayout>
  );
};
